import React from 'react';
import tinycolor from 'tinycolor2';

const MinimalistTurtle = (props) => {
  const { radius, cells } = props;

  const base = cells[1].background;
  const light = tinycolor(base).lighten(20).toString();

  return (
    
    <svg width={`${radius * 2.875}px`} height={`${radius * 1.5}px`} x={`-${radius * 1.125}px`} y={`-${radius}px`} viewBox="0 0 286 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Artboard">
              <g id="Group">
                <path d="M0,87 C-1.26816328e-15,93.9035594 5.59644063,99.5 12.5,99.5 L12.5,87 L0,87 Z" id="Oval-2" fill={light}></path>
                <path d="M36,150 C63.6142375,150 86,127.614237 86,100 L36,100 L36,150 Z" id="Oval-2" fill={light}></path>
                <path d="M186,150 C158.385763,150 136,127.614237 136,100 L186,100 L186,150 Z" id="Oval-2-Copy" fill={light}></path>
                <path d="M286,25 C244.578644,25 211,58.5786438 211,100 L286,100 L286,25 Z" id="Oval-2" fill={light}></path>
                <circle id="Oval" fill="#FFFFFF" cx="266.5" cy="50.5" r="7.5"></circle>
                <path d="M212,100 C212,44.771525 167.228475,0 112,0 C56.771525,0 12,44.771525 12,100 L212,100 Z" id="Oval-3" fill={base}></path>
              </g>
          </g>
        </g>
    </svg>
  )
}
export default MinimalistTurtle;

export function resize(props) {
  const {radius, minX, maxX, maxY} = props;

  return {
    ...props,
    minX: minX + radius * .125,
    maxX: maxX + radius * .75,
    maxY: maxY + radius * .5,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/minimalist/turtle/index.js